import React, { useCallback, useEffect, useRef, useState } from 'react'
import FilterBar from './_elements/FilterBar';
import Books from './_elements/Books';
import { IStore } from 'redux/store';
import { Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import moment from 'moment';
import DateRangeSelector from 'components/app/_common/DateRangeSelector';
import DatePagination from 'components/app/_common/DatePagination';
import SearchBar from './_elements/SearchBar';
import Button from './_elements/Button';
import classNames from 'classnames';
import { EBookType, IBook, IEntry } from 'redux/app/vessel/types';
import ReactToPrint from 'react-to-print';
import { inspectorActions, inspectorSelectors } from 'redux/app/vessel/inspector';
import { IDateRange } from 'redux/app/vessel/inspector/types';
import inspectorConstants from 'redux/app/vessel/inspector/constants';
import { vesselActions, vesselSelectors } from 'redux/app/vessel';
import { checklistActions } from 'redux/app/checklist';
import { commonUtils } from 'redux/_common';
import MarpolPrintIcon from './_elements/MarpolPrintIcon';
import LogPrintIcon from './_elements/Logs/LogPrintIcon';
import LogInspectorView from './_elements/Logs/LogInspectorView';
import TemplateRenderer from './_elements/TemplateRenderer';
import SealLogsInspectorView from './_elements/SealLogsInspectorView';
import Modal from 'components/app/_common/Modal';
import { getDate } from 'redux/app/vessel/inspector/utils';
import MarpolInspectorView from './_elements/Marpol/MarpolInspectorView';
import orb4Selectors from 'redux/app/orb4/selectors';
import { orb1Selectors } from 'redux/app/orb1';
import { crbSelectors } from 'redux/app/crb';
import { garbageRecordSelectors } from 'redux/app/garbage-record';
import { grb2Selectors } from 'redux/app/grb2';
import { bfl1Selectors } from 'redux/app/bfl-1';
import { bfl2Selectors } from 'redux/app/bfl-2';
import { annex6Selectors } from 'redux/app/annex6';
import { ballastActions, ballastSelectors } from 'redux/app/ballast';
import { TTableBallastTank } from 'redux/app/ballast/@types';
import Dropdown from 'components/_common/Dropdown';
import { annex6V2Selectors } from 'redux/app/annex6-v2';

const logViewWithCoverPage = [
	'gmdssRadioConfig',
	'compassLogConfig',
	'portLogConfig',
	'engineLogConfig',
	'deckLogConfig',
	'medicalLogConfig',
];

const printIframe = async (id: string) => {
	// @ts-ignore
	const iframe = document.frames
		? // @ts-ignore
		document.frames[id]
		: document.getElementById(id);
	const iframeWindow = iframe?.contentWindow || iframe;

	console.log('iframeWindow: ', iframeWindow);

	console.log('Print button clicked, previewing...');
	// preview
	await (iframeWindow as any)?.PagedPolyfill?.preview();

	iframe.focus();
	iframeWindow.print();

	// after printing is completed or cancelled, refresh the page
	window.location.reload();

	return false;
};

type OwnProps = {
	vesselId: string;
};
type InspectorProps = PropsFromRedux & OwnProps;
function Inspector(props: InspectorProps) {
	const {
		vesselId,
        dateRange,
        entry,
        pagination,
        setDateRange,
        clearDateRange,
        logs,
        selectedLogId,
        isLogPresent,
        books,
        filteredBy,
        searchBy,
        logData,
        submissionsMapper,
        jobToLoadAllLogsOfADay,
		jobToGetChecklists,
        jobToLoadAssociatedDayLog,
        jobToGetLogs,
        jobToGetSealLogs,
        jobToGetLogConfigs,
        jobToLoadORB1History,
        jobToLoadORB4History,
		jobToLoadCRBHistory,
        jobToLoadGRB1History,
        jobToLoadGRB2History,
        jobToLoadBFL1History,
        jobToLoadBFL2History,
        jobToLoadAnnex6History,
        jobToLoadBallastHistory,
        jobToLoadTableLogs, // for ballast-tank-operations
        ballastTanks, 
        vesselFlag,
        selectedDateRange,
        jobToLoadLogsCount,
        jobToLoadPrintTemplate,
		jobToGetIndexOfTasks,
    } = props;

	const zoomInRef = useRef();
    const zoomOutRef = useRef();
    const setDefaultStateRef = useRef();
    const transformComponentRef = useRef<HTMLDivElement>(null!);
    const printRef = useRef<HTMLDivElement>(null!);
    const [isDrag, setIsDrag] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isPrintDisabled, setIsPrintDisabled] = useState(false);
    const [isDateRangeExceeded, setIsDateRangeExceeded] = useState(false);
	const [currentSelectedLog, setCurrentSelectedLog] = useState<any>(undefined);

 	// Ballast Tank operations state
	const [ballastTank, setBallastTank] = useState(ballastTanks[0]);

	const isDataLoading =
        jobToLoadAllLogsOfADay.isLoading ||
		jobToGetChecklists.isLoading ||
        jobToLoadAssociatedDayLog.isLoading ||
        jobToGetLogConfigs.isLoading ||
        jobToGetLogs.isLoading ||
        jobToGetSealLogs.isLoading ||
        jobToLoadORB1History.isLoading ||
        jobToLoadORB4History.isLoading ||
        jobToLoadCRBHistory.isLoading ||
        jobToLoadGRB1History.isLoading ||
        jobToLoadGRB2History.isLoading ||
        jobToLoadBFL1History.isLoading ||
        jobToLoadBFL2History.isLoading ||
        jobToLoadAnnex6History.isLoading ||
        jobToLoadBallastHistory.isLoading ||
        jobToLoadTableLogs.isLoading ||
        jobToLoadLogsCount.isLoading ||
        jobToLoadPrintTemplate.isLoading;

	useEffect(() => {
			props.loadLogbookPersonnels(vesselId);
        	props.loadGlobalSettings(vesselId);
	    	props.getBallastTanks(vesselId);
        	// eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
	
	useEffect(() => {
		const fullScreenChangeHandler = function (e: Event) {
			if (document.fullscreenElement) {
				setIsFullScreen(true);
			} else {
				setIsFullScreen(false);
			}
		};

		document.addEventListener('fullscreenchange', fullScreenChangeHandler);
		return () => {
			document.removeEventListener(
				'fullscreenchange',
				fullScreenChangeHandler
			);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		props.getIndexOfTasks(vesselId);
	}, [vesselId]); 

	const entryId = entry?.id;
	const entryType = entry?.type;

	useEffect(() => {
		if (entryId && entryType && logs && logs?.length) {
			const firstLog = logs[0];
			setCurrentSelectedLog(firstLog);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [entryId, logs]);

	const currentSelectedLogId = currentSelectedLog?._id;

	useEffect(() => {
		if (
			entryId &&
			currentSelectedLogId &&
			entryType === 'LOG' &&
			entryId !== 'engineLogConfig'
		) {
			console.log("Getting print template for log with entryId: ", entryId);

			props.getPrintTemplateForSelectedLog(
				entryId,
				vesselId,
				currentSelectedLog?.versionInfo?.config
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentSelectedLogId]);

	useEffect(() => {
        if (logs && Array.isArray(logs) && logs.length > 0) {
            props.setIndex(0);
            const modelname = logs[0]?.modelName;
            if (modelname === 'permitLogs') {
                // If logs are permitLogs, we expect an array of logs
                const date = logs[0]?.selectedDate;
                setSelectedLog(logs, date);
            } else {
                // For other types of logs, we can just set the first log
                setSelectedLog(logs[0]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [logs]);

	useEffect(() => {
		if (logData && entry) {
			const date = getDate(logData, entry?.type);
			if (date) {
				const diff = moment().diff(date, 'M');
				const isPrintDisabled = diff > 3;
				setIsPrintDisabled(isPrintDisabled);
			}
		}
	}, [logData, entry]);

	// don't show cover pages when user changes the book or type
	useEffect(() => {
		props.setShowCoverPages(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [entry?.id, entry?.type]);

	// don't show cover pages once component is unmounted
	useEffect(() => {
		return () => {
			props.setShowCoverPages(false);
			props.setBallastTankCode('');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const toggleFullScreen = () => {
		let elem = document.querySelector('#printTemplateRenderer');
		if (!document.fullscreenElement && elem) {
			elem.requestFullscreen();
		} else {
			if (document.exitFullscreen) {
				document
					.exitFullscreen()
					.then(() => {
						console.log('Document exited from full screen mode');
					})
					.catch((err) => {
						console.log(err);
					});
			}
		}
	};

	function setSelectedLog(log: any[] | any, date?: string) {
		 if (log?.modelName === 'permitLogs') {
            // Single permitLog case
            props.setLogId(log._id);
            props.setLogType(log.modelName);
            props.logSelect([log]); // Wrap single log in array
            props.getPrintTemplateForSelectedChecklist(
                log.code,
                vesselId,
                log?.versionInfo?.config
            );
            console.log('Selected permit log:', log);
        } else if (
            Array.isArray(log) &&
            log.length > 0 &&
            log[0]?.modelName === 'permitLogs'
        ) {
            // Array of permitLogs case (when date filtering is needed)
            const logs = date
                ? log?.filter((l) => l?.selectedDate === date)
                : log;
            props.setLogId(logs[0]._id);
            props.setLogType(logs[0].modelName);
            props.logSelect(logs);
            props.getPrintTemplateForSelectedChecklist(
                logs[0].code,
                vesselId,
                logs[0]?.versionInfo?.config
            );
            console.log('Selected permit logs:', logs);
        } else if (!Array.isArray(log)) {
            // Single log case for other log types
            props.setLogId(log._id);
            props.setLogType(log.modelName);

            if (['checklistLogs', 'assessmentLogs'].includes(log.modelName)) {
                props.logSelect([log]);
                props.getPrintTemplateForSelectedLog(
                    log.code,
                    vesselId,
                    log?.versionInfo?.config
                );
                console.log('Selected log not permit:', log);
            } else {
                console.log(
                    'Selected log not permit, getting all logs of the day:',
                    log
                );
                let configId = log?.code;
                props.getAllLogsOfADay(
                    log.selectedDate,
                    configId,
                    log.intlDateLineRecord,
					vesselId,
                );
            }
        }
	}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const debouncedSelectedLogHandler = useCallback(
		commonUtils.debounce(setSelectedLog, 600),
		[]
	);

	const isRendererExist = selectedLogId && entry && entry.id;

	const getPdfDownloadUrl = () => {
		const prefix =
			process.env.NODE_ENV === 'development'
				? window.location.origin
				: window.location.origin + '/ui';
		const apiUrlPrefix =
			process.env.NODE_ENV === 'development'
				? process.env.REACT_APP_DOMAIN
				: window.location.origin + '/api';

		const publicUrl = `${prefix}/#/public/print/marpol/${entry?.id?.toLowerCase()}/${commonUtils.getStartOfDay(
			moment(selectedDateRange.startDate).format('YYYY-MM-DD')
		)}/${commonUtils.getStartOfDay(
			moment(selectedDateRange.endDate).format('YYYY-MM-DD')
		)}`;
		const footerContent = `${moment(selectedDateRange.startDate).format(
			'DD-MM-YYYY'
		)} to ${moment(selectedDateRange.endDate).format(
			'DD-MM-YYYY'
		)} | Wayship v1.0.62 | by - Volteo Maritime`;

		const encodedURL = `${apiUrlPrefix}/pdf?url=${encodeURIComponent(
			publicUrl
		)}&footerContent=${footerContent}`;

		return encodedURL;
	};

	// INFO: in marpol handle case of liberia flag -  where annex6 v2 needs to be shown.
	function getFlagBasedBooks(
		books: IBook[],
		filterBy: EBookType | null,
		flag: string | undefined
	) {
		// if ((filterBy === EBookType.MARPOL || filterBy === null) && flag) {
		//     if (flag.toLowerCase() === 'liberia') {
		//         return books.filter((book) => book.id !== 'ANNEX6');
		//     } else {
		//         return books.filter((book) => book.id !== 'ANNEX6V2');
		//     }
		// }

		// INFO: Don't want to show signal report.
		if (!filterBy || filterBy === 'LOG') {
			return books.filter((book) => book.id !== 'signalReportConfig');
		}

		return books;
	}

	const flagBasedBooks = getFlagBasedBooks(books, filteredBy, vesselFlag);

	const isDownloadDisabled =
		!entry ||
		entry?.type !== EBookType.MARPOL ||
		filteredBy !== EBookType.MARPOL ||
		isDataLoading;
	return (
		<div className="grid h-full grid-cols-10 p-2 pb-3 overflow-hidden gap-x-2">
			<section className="col-span-2 shadow-[0px_0px_1px_rgba(0,0,0,0.48)] rounded-md bg-white">
				<div className="p-5 flex flex-col gap-y-2 border-b-[0.3px] border-[#CDCDCD]">
					<SearchBar
						setBooksUsingSearchBy={props.setBooksUsingSearchBy}
						setSearchBy={props.setSearchBy}
						searchBy={searchBy}
					/>
					<FilterBar
						setFilteredBy={props.setFilteredBy}
						filteredBy={filteredBy}
					/>
				</div>
				<Books
					books={flagBasedBooks}
					isLoading={jobToGetIndexOfTasks.isLoading}
					onClick={(entry) => {
						props.setEntry(entry);
						if (entry.type === 'MARPOL') {
							props.getAppropriateMarpolRecords(entry, vesselId);
						} else if (entry.id === 'sealLogs') {
							props.getSealLogs(entry, vesselId);
						} else {
							props.getLogsCount(vesselId);
							if (entry.type !== 'LOG') {
								setIsDrag(false);
								if (setDefaultStateRef.current) {
									(setDefaultStateRef.current as any)();
								}
								// props.getConfigForSelectedLog(
								// 	entry.type,
								// 	entry?.bookType || "",
								// 	vesselId,
								// );
							}
							if (
								entry.type !== 'PERMIT' &&
								entry.id !== 'engineLogConfig'
							) {
								// Do Nothing.
                                // props.getPrintTemplateForSelectedLog(
                                //     entry.id,
                                //     undefined,
                                //     recordConfigVersion
                                // );
							}
						}
					}}
				/>
			</section>
			<section className="flex flex-col col-span-8 gap-y-2 bg-backgroundPrimary">
				<div className="drop-shadow-[rgba(0,0,0,0.12)] shadow-[0px_0px_4px_rgba(0,0,0,0.12)] bg-gray-100 rounded-md px-3 py-2 flex flex-col justify-between gap-y-1 lg:max-h-[100px]">
					<div className="flex items-baseline gap-x-2 leading-0 text-logo_icon font-medium">
						<h3 className="text-lg font-medium">Inspector View</h3>
						{entry ? (
							<>
								<h5 className="text-sm ">{entry.title}</h5>
								<p className="ml-auto text-xs">
									{entry?.type === EBookType.MARPOL
										? entry?.id in submissionsMapper &&
											typeof submissionsMapper[entry.id] ===
											'number' &&
											submissionsMapper[entry.id] > 0 &&
											dateRange.startDate &&
											dateRange.endDate
											? `${submissionsMapper[entry.id]
											} Submissions`
											: ''
										: entry?.type === EBookType.LOG &&
											entry.id === 'sealLogs'
											? `${props.sealLogs?.length || 0
											} Submissions`
											: `${pagination?.count || 0
											} Submissions`}
								</p>
							</>
						) : null}
					</div>
					<div className="flex lg:flex-row lg:items-center flex-col items-start justify-between gap-x-5 gap-y-2">
						<article className="flex items-center">
							<DateRangeSelector
								disabled={entry?.id ? false : true}
								dateRangeValue={dateRange}
								setDateRange={setDateRange}
								clearDateRange={clearDateRange}
								onFilter={() => {
									if (entry?.id === 'sealLogs') {
										props.getSealLogs(entry, vesselId);
									} else {
										props.getLogsCount(vesselId);
									}
								}}
							/>
							{entry &&
                            entry.type === EBookType.MARPOL &&
                            entry.id === 'BALLAST_TANK_OPERATIONS' ? (
                                <div className="ml-4">
                                    <Dropdown
                                        id="ballast-place-id"
                                        inputWrapperProps={{}}
                                        disabled={false}
                                        options={ballastTanks}
                                        renderView={(selectedItem) => (
                                            <div className="break-all">
                                                {selectedItem.label}
                                            </div>
                                        )}
                                        value={ballastTank.value}
                                        onSelect={(selectedTank) => {
                                            if (selectedTank) {
                                                setBallastTank(selectedTank);
                                                props.setBallastTankCode(
                                                    selectedTank.value
                                                );
                                                props.getLogsCount(vesselId);
                                            }
                                        }}
                                    />
                                </div>
                            ) : null}
						</article>
						<article className="self-stretch flex-1 overflow-hidden">
							{entry && entry.type === EBookType.MARPOL ? null : (
								<DatePagination
									logs={logs}
									setSelectedLog={(log, date) => {
										setCurrentSelectedLog(log);
										debouncedSelectedLogHandler(log, date);
									}}
									entry={entry}
									index={pagination.index}
									setIndex={props.setIndex}
								/>
							)}
						</article>
						<article className="flex items-center gap-x-2">
							{!isDownloadDisabled && (
								<a
									href={getPdfDownloadUrl()}
									target="_blank"
									rel="noreferrer"
								>
									<div className="flex items-center justify-center p-3 rounded-full bg-pagination_background group">
										<span
											className={`bp3-icon bp3-icon-import text-lg text-fontWayship group-hover:text-blue-700`}
										/>
									</div>
								</a>
							)}
							{entry &&
								(entry.type === EBookType.MARPOL ||
									entry.id === 'sealLogs') ? (
								<>
									{/* prompt the user to ask whether cover pages to be included in the print */}
									<MarpolPrintIcon
										dateRange={dateRange}
										isDataLoading={isDataLoading}
										printIframe={printIframe}
										isDisabled={
											(!dateRange?.startDate &&
												!dateRange?.endDate) ||
											isDataLoading
											// || !isRendererExist
										}
										printRef={printRef}
									/>

									{/* {showCoverPages ? (
                                        <Button
                                            // disabled={!isRendererExist}
                                            disabled={
                                                (!dateRange?.startDate &&
                                                    !dateRange?.endDate) ||
                                                isDataLoading
                                            }
                                            iconName="print"
                                            onClick={() => {
                                                if (!showCoverPages) {
                                                    props.setShowCoverPages(
                                                        true
                                                    );
                                                }
                                                printIframe('printIframe');
                                                // printMarpolModule();
                                            }}
                                        />
                                    ) : (
                                        <ReactToPrint
                                            trigger={() => (
                                                <Button
                                                    disabled={
                                                        (!dateRange?.startDate &&
                                                            !dateRange?.endDate) ||
                                                        isDataLoading
                                                    }
                                                    iconName="print"
                                                />
                                            )}
                                            content={() => printRef.current}
                                        />
                                    )} */}
								</>
							) : entry &&
								entry?.type === EBookType.LOG &&
								logViewWithCoverPage.includes(entry?.id) ? (
								<LogPrintIcon
									dateRange={dateRange}
									isDisabled={
										!dateRange?.startDate &&
										!dateRange?.endDate
									}
									transformComponentRef={
										transformComponentRef
									}
								/>
							) : (
								<ReactToPrint
									// onBeforeGetContent={() => {
									//     const frames = window?.frames;
									//     const section =
									//         document.createElement('section');
									//     let newStyle = null;
									//     let isStyle = false;
									//     console.log('frames: ', frames);
									//     for (
									//         let i = 0;
									//         i < frames.length;
									//         i++
									//     ) {
									//         const frame = frames[i];
									//         // cons
									//         if (frame) {
									//             if (!isStyle) {
									//                 const elm =
									//                     frame.document
									//                         .documentElement;
									//                 const styles =
									//                     elm.getElementsByTagName(
									//                         'style'
									//                     );
									//                 for (
									//                     let i = 0;
									//                     i < styles.length;
									//                     i++
									//                 ) {
									//                     const style =
									//                         styles.item(i);
									//                     if (style) {
									//                         isStyle = true;
									//                         newStyle =
									//                             style.cloneNode(
									//                                 true
									//                             );
									//                         section.appendChild(
									//                             style.cloneNode(
									//                                 true
									//                             )
									//                         );
									//                     }
									//                 }
									//             }
									//             const body =
									//                 frame.document.body;
									//             const children = body.children;
									//             const article =
									//                 document.createElement(
									//                     'article'
									//                 );
									//             for (
									//                 let i = 0;
									//                 i < children.length;
									//                 i++
									//             ) {
									//                 const child =
									//                     children.item(i);
									//                 if (child) {
									//                     if (
									//                         child.tagName !==
									//                         'SCRIPT'
									//                     ) {
									//                         if (
									//                             child.id !==
									//                             'transformComponentRef'
									//                         ) {
									//                             article.appendChild(
									//                                 child.cloneNode(
									//                                     true
									//                                 )
									//                             );
									//                         }
									//                     }
									//                 }
									//             }
									//             section.appendChild(article);
									//             console.log(
									//                 'section:',
									//                 section
									//             );
									//         }
									//     }
									//     transformComponentRef.current.replaceChildren();
									//     transformComponentRef.current.appendChild(
									//         section
									//     );
									//     const elm =
									//         document.getElementById(
									//             'printWindow'
									//         );
									//     if (elm && newStyle) {
									//         console.log('elm present');
									//         elm.appendChild(newStyle as any);
									//     }
									// }}
									trigger={() => (
										<Button
											disabled={
												!isRendererExist ||
												isDataLoading
											}
											iconName="print"
										/>
									)}
									// onAfterPrint={() => {
									//     console.log('onAfterPrint');
									//     transformComponentRef.current.replaceChildren();
									// }}
									// onPrintError={() => {
									//     console.log('onPrintError');
									//     transformComponentRef.current.replaceChildren();
									// }}
									content={() =>
										transformComponentRef.current
									}
								/>
							)}
							<Button
								disabled={!isRendererExist}
								title="Drag"
								iconName="move"
								onClick={() => {
									setIsDrag((prev) => !prev);
									if (setDefaultStateRef.current) {
										(setDefaultStateRef.current as any)();
									}
								}}
								isActive={isDrag}
							/>
							<Button
								disabled={!isDrag || !isRendererExist}
								title="Zoom In"
								iconName="zoom-in"
								onClick={zoomInRef.current}
							/>
							<Button
								disabled={!isDrag || !isRendererExist}
								title="Zoom Out"
								iconName="zoom-out"
								onClick={zoomOutRef.current}
							/>
							<Button
								disabled={!isRendererExist}
								title="Full screen"
								iconName="fullscreen"
								onClick={toggleFullScreen}
							/>
						</article>
					</div>
				</div>
				<div
					className={classNames(
						'shadow-[0px_0px_1px_rgba(0,0,0,0.48)] rounded-md h-full max-h-[calc(100vh-128px)] overflow-hidden p-2 relative',
						{
							'overflow-y-auto ws-scroll':
								entry &&
								(entry.type === EBookType.MARPOL ||
									entry.id === 'sealLogs' ||
									(entry.type === EBookType.LOG &&
										logViewWithCoverPage?.includes(
											entry?.id
										))) &&
								!isDataLoading,
						}
					)}
				>
					{isDataLoading && (
						<div
							className={classNames(
								'h-[calc(100vh-128px)] overflow-hidden'
							)}
						>
							<div className="flex items-center justify-center h-full">
								<div className="flex flex-col items-center justify-center h-full">
									<div className="w-20 h-20 border-4 border-r-4 border-blue-300 border-solid rounded-full border-t-transparent animate-spin opacity-80"></div>
									<p className="mt-4 text-lg text-center text-blue-400">
										Sailing to you in a moment
									</p>
								</div>
							</div>
						</div>
					)}

					{isLogPresent ||
						(entry &&
							(entry.type === EBookType.MARPOL ||
								entry.id === 'sealLogs')) ? (
						<div
							id="printTemplateRenderer"
							className="relative bg-white"
						>
							{isFullScreen ? (
								<div className="flex items-center justify-center px-4 py-2 bg-white gap-x-2">
									{!!isPrintDisabled ? (
										<ReactToPrint
											trigger={() => (
												<Button
													isActive={
													    !jobToLoadAllLogsOfADay.isLoading ||
													    !jobToLoadAssociatedDayLog.isLoading ||
													    !jobToGetLogConfigs.isLoading ||
													    !jobToGetLogs.isLoading ||
													    !jobToLoadORB1History.isLoading ||
													    !jobToLoadORB4History.isLoading ||
													    !jobToLoadCRBHistory.isLoading ||
													    !jobToLoadGRB1History.isLoading ||
													    !jobToLoadGRB2History.isLoading ||
														!jobToLoadBFL1History.isLoading ||
													    !jobToLoadAnnex6History.isLoading ||
													    !jobToLoadBallastHistory.isLoading ||
														!jobToLoadTableLogs.isLoading
													}
													iconName="print"
												/>
											)}
											content={() =>
												transformComponentRef.current
											}
										/>
									) : null}
									<Button
										// disabled={(entry && entry.type !== 'LOG')}
										title="Drag"
										iconName="move"
										onClick={() => {
											setIsDrag((prev) => !prev);
											if (setDefaultStateRef.current) {
												(
													setDefaultStateRef.current as any
												)();
											}
										}}
										isActive={isDrag}
									/>
									<Button
										disabled={!isDrag}
										title="Zoom In"
										iconName="zoom-in"
										onClick={zoomInRef.current}
									/>
									<Button
										disabled={!isDrag}
										title="Zoom Out"
										iconName="zoom-out"
										onClick={zoomOutRef.current}
									/>
									<Button
										title="Exit full screen"
										iconName="zoom-to-fit"
										onClick={toggleFullScreen}
									/>
								</div>
							) : null}

							{entry &&
								(entry.type === EBookType.MARPOL ||
									entry.id === 'sealLogs') ? (
								// <ORB1History />
								!dateRange?.startDate && !dateRange.endDate ? (
									<div className="flex bg-backgroundPrimary items-center justify-center h-[calc(100vh-98px)] text-xl text-fontWayship font-normal">
										Please select date range
									</div>
								) : entry.type === EBookType.MARPOL ? (
									<MarpolInspectorView
										bookId={entry.id}
										iframeRef={printRef}
									/>
								) : (
									<SealLogsInspectorView
										bookId={entry.id}
										iframeRef={printRef}
									/>
								)
							) : entry?.type === EBookType.LOG &&
								logViewWithCoverPage.includes(entry?.id) ? (
								<LogInspectorView
									bookId={entry?.id}
									isFullScreen={isFullScreen}
									isDrag={isDrag}
									zoomInRef={zoomInRef}
									zoomOutRef={zoomOutRef}
									setDefaultStateRef={setDefaultStateRef}
									transformComponentRef={
										transformComponentRef
									}
								/>
							) : (
								<TemplateRenderer
									isFullScreen={isFullScreen}
									isDrag={isDrag}
									zoomInRef={zoomInRef}
									zoomOutRef={zoomOutRef}
									setDefaultStateRef={setDefaultStateRef}
									transformComponentRef={
										transformComponentRef
									}
								/>
							)}
						</div>
					) : (
						<div className="flex items-center justify-center h-full text-xl text-fontWayship font-normal">
							{entry && entry.id
								? selectedLogId
									? 'No log found! (Note: only approved logs are visible)'
									: 'Please select a log! (Note: only approved logs are visible)'
								: 'Please select a book!'}
						</div>
					)}
				</div>
			</section>
			{isDateRangeExceeded ? (
				<Modal
					isActive={isDateRangeExceeded}
					onClose={() => setIsDateRangeExceeded(false)}
					className="items-start"
				>
					<div className="flex justify-center my-12 font-redhat-text ">
						<div
							className="relative w-1/2 h-auto p-4 my-1 bg-backgroundSecondary rounded-lg xl:w-2/5"
						// style={{ width: '50%' }}
						>
							<div className="flex items-center justify-between p-2">
								<p className="text-base font-medium text-fontWayship">
									PDF cannot be generated.
								</p>
								<span
									onClick={() => {
										setIsDateRangeExceeded(false);
									}}
									className="text-xl cursor-pointer bp3-icon bp3-icon-cross text-fontWayship"
								/>
							</div>

							<div className="text-red-400 text-sm p-2.5 my-0 mb-2 ">
								Date range has exceeded, please ensure
								difference is not greater than 3 months.
							</div>
						</div>
					</div>
				</Modal>
			) : null}
		</div>
	)
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const inspectorStore = inspectorSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);

	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);

	const selectedDateRange = inspectorSelectors.getDateRange(inspectorStore);
	const selectedLog = inspectorSelectors.getSelectedLog(inspectorStore);
	const logData = Array.isArray(selectedLog?.log)
		? selectedLog?.log[0]
		: selectedLog?.log;
	const logs = inspectorSelectors.getLogs(inspectorStore);
	const isLogPresent =
		selectedLog &&
		selectedLog.log &&
		(Array.isArray(selectedLog?.log)
			? selectedLog.log.length > 0
			: Object.keys(selectedLog.log).length > 0) &&
		logs &&
		Array.isArray(logs) &&
		logs.length > 0;
	
	const orb1RecordStore = orb1Selectors._getStore(store);
	const orb4RecordStore = orb4Selectors._getStore(store);
	const crbRecordStore = crbSelectors._getStore(store);
	const garbageRecordStore = garbageRecordSelectors._getStore(store);
	const grb2RecordStore = grb2Selectors._getStore(store);
	const bfl1RecordStore = bfl1Selectors._getStore(store);
	const blf2RecordStore = bfl2Selectors._getStore(store);
	const annex6RecordStore = annex6Selectors._getStore(store);
	const ballastRecordStore = ballastSelectors._getStore(store);
	const orb1historyRecords = orb1Selectors.getHistoryList(orb1RecordStore);
	const orb4historyRecords = orb4Selectors.getHistoryList(orb4RecordStore);
	const crbhistoryRecords = crbSelectors.getHistoryList(crbRecordStore);
	const garbagehistoryRecords =
	garbageRecordSelectors.getHistoryList(garbageRecordStore);
	const grb2historyRecords = grb2Selectors.getHistoryList(grb2RecordStore);
	const bfl1historyRecords = bfl1Selectors.getHistoryList(bfl1RecordStore);
	const bfl2historyRecords = bfl2Selectors.getHistoryList(blf2RecordStore);
	const annexhistoryList = annex6Selectors.getHistoryList(annex6RecordStore);
	const annex6V2RecordStore = annex6V2Selectors._getStore(store);
	const annex6V2historyList =
		annex6V2Selectors.getHistoryList(annex6V2RecordStore);
	const ballasthistoryRecords =
		ballastSelectors.getHistoryList(ballastRecordStore);
	// For ballast tank operations
	const ballastStore = ballastSelectors._getStore(store);
	const tableLogs = ballastSelectors.getTableLogs(ballastStore);

	const submissionsMapper: Record<string, number> = {
		ORB1: orb1historyRecords?.length ?? 0,
		ORB4: orb4historyRecords?.length ?? 0,
		CRB: crbhistoryRecords?.length ?? 0,
		GRB1: garbagehistoryRecords?.length ?? 0,
		GRB2: grb2historyRecords?.length ?? 0,
		BFL1: bfl1historyRecords?.length ?? 0,
		BFL2: bfl2historyRecords?.length ?? 0,
		ANNEX6: annexhistoryList?.length ?? 0,
        ANNEX6V2: annex6V2historyList?.length ?? 0,
		BALLAST: ballasthistoryRecords?.length ?? 0,
		BALLAST_TANK_OPERATIONS: tableLogs?.length ?? 0,
	};

	const jobToLoadAllLogsOfADay =
		inspectorSelectors.jobToLoadAllLogsOfADay(inspectorStore);
	const jobToGetChecklists =
		inspectorSelectors.jobToGetChecklists(inspectorStore);
	const jobToGetIndexOfTasks =
		inspectorSelectors.jobToGetIndexOfTasks(inspectorStore);
	const jobToLoadAssociatedDayLog =
		inspectorSelectors.jobToLoadAssociatedDayLog(inspectorStore);
	const jobToGetLogs = inspectorSelectors.jobToGetLogs(inspectorStore);
	const jobToGetSealLogs =
		inspectorSelectors.jobToGetSealLogs(inspectorStore);
	const jobToGetLogConfigs =
		inspectorSelectors.jobToGetLogConfig(inspectorStore);
	const jobToLoadORB1History =
		orb1Selectors.jobToLoadHistory(orb1RecordStore);
	const jobToLoadORB4History =
	    orb4Selectors.jobToLoadHistory(orb4RecordStore);
	const jobToLoadCRBHistory =
	    crbSelectors.jobToLoadHistory(crbRecordStore);
	const jobToLoadGRB1History =
		garbageRecordSelectors.jobToLoadHistory(garbageRecordStore);
	const jobToLoadGRB2History =
		grb2Selectors.jobToLoadHistory(grb2RecordStore);
	const jobToLoadBFL1History =
		bfl1Selectors.jobToLoadHistory(bfl1RecordStore);
	const jobToLoadBFL2History =
	    bfl2Selectors.jobToLoadHistory(blf2RecordStore);
	const jobToLoadAnnex6History =
	    annex6Selectors.jobToLoadHistory(annex6RecordStore);
	const jobToLoadBallastHistory =
	    ballastSelectors.jobToLoadHistory(ballastRecordStore);
	const jobToLoadLogsCount =
		inspectorSelectors.jobToGetLogsCount(inspectorStore);
	const jobToLoadPrintTemplate =
		inspectorSelectors.jobToGetLogPrintTemplate(inspectorStore);

	const showCoverPages = inspectorSelectors.getShowCoverPages(inspectorStore);
	const jobToLoadTableLogs =
	    ballastSelectors.jobToLoadTableLogs(ballastStore);
	const sealLogs = inspectorSelectors?.getSealLogs(inspectorStore);
	
	let ballastTanks = ballastSelectors.getBallastTanks(ballastStore);
	
    if (ballastTanks && ballastTanks.length > 0) {
        ballastTanks = ballastTanks.map((tank: TTableBallastTank) => {
            let { label, value } = tank;
            return {
                label,
                value,
            };
        });
        ballastTanks = [
            ...[{ value: '', label: 'All Tanks' }],
            ...ballastTanks,
        ];
    } else {
        ballastTanks = [{ value: '', label: 'All Tanks' }];
    }

	return {
		dateRange: inspectorSelectors.getDateRange(inspectorStore),
		entry: inspectorSelectors.getEntryFilter(inspectorStore),
		logs,
		pagination: inspectorSelectors.getPagination(inspectorStore),
		selectedLogId: inspectorSelectors.getSelectedLogId(inspectorStore),
		isLogPresent,
		books: inspectorSelectors.getBooks(inspectorStore),
		filteredBy: inspectorSelectors.getFilteredBy(inspectorStore),
		searchBy: inspectorSelectors.getSearchBy(inspectorStore),
		logTemplate: selectedLog?.logPrintTemplate,
		logConfig: selectedLog?.logConfig,
		logData,
		logType: selectedLog?.logType,
		jobToLoadAllLogsOfADay,
		jobToGetChecklists,
		jobToLoadAssociatedDayLog,
		jobToGetLogs,
		jobToGetSealLogs,
		jobToGetLogConfigs,
		submissionsMapper,
		jobToLoadORB1History,
		jobToLoadORB4History,
		jobToLoadCRBHistory,
		jobToLoadGRB1History,
		jobToLoadGRB2History,
		jobToLoadBFL1History,
		jobToLoadBFL2History,
		jobToLoadAnnex6History,
		jobToLoadBallastHistory,
		jobToLoadTableLogs,
		jobToLoadLogsCount,
		jobToLoadPrintTemplate,
		showCoverPages,
		selectedDateRange,
		vesselFlag: vesselInfo?.flag,
		sealLogs,
		jobToGetIndexOfTasks,
		ballastTanks,
	};
}

function mapDispatchToProps(dispatch: Dispatch) {
	return {
		setEntry(entry: IEntry) {
			return dispatch(inspectorActions.document.setEntry(entry));
		},
		setDateRange(dateRange: IDateRange) {
			return dispatch(inspectorActions.document.setDateRange(dateRange));
		},
		clearDateRange() {
			return dispatch(inspectorActions.commands.clearDateRange());
		},
		getLogsCount(vesselId: string) {
			return dispatch(inspectorActions.commands.getLogsCount(vesselId));
		},
		getAppropriateMarpolRecords(entry: IEntry, vesselId: string) {
			return dispatch(
				inspectorActions.commands.getAppropriateMarpolRecords(entry, vesselId)
			);
		},
		getSealLogs(entry: IEntry, vesselId: string) {
			return dispatch(inspectorActions.commands.getSealLogs(entry, vesselId));
		},
		setIndex(index: number) {
			return dispatch(inspectorActions.document.setIndex(index));
		},
		setLogId(id: any) {
			return dispatch(inspectorActions.document.setLogId(id));
		},
		setLogType(type: any) {
			return dispatch(inspectorActions.document.setLogType(type));
		},
		logSelect(logs: any[]) {
			return dispatch(inspectorActions.document.logSelect(logs));
		},
		getConfigForSelectedLog(code: string, documentType: string, vesselId: string) {
			return dispatch(
				inspectorActions.commands.getLogConfig(code, documentType, vesselId)
			);
		},
		getPrintTemplateForSelectedLog(code: string, vesselId: string, recordConfigVersion?: string) {
			return dispatch(
				inspectorActions.commands.getLogPrintTemplate(
					code,
					inspectorConstants.FEATURE,
					vesselId,
					recordConfigVersion,
				)
			);
		},
		getPrintTemplateForSelectedChecklist(code: string, vesselId: string, recordConfigVersion?: string) {
			return dispatch(
				inspectorActions.commands.getChecklistPrintTemplate(
					code,
					inspectorConstants.FEATURE,
					vesselId,
					recordConfigVersion,
				)
			);
		},
		getAllLogsOfADay(
			selectedDate: string,
			logCode: string,
			intlDateLineRecord: boolean,
			vesselId: string,
		) {
			return dispatch(
				inspectorActions.commands.getAllLogsOfADay(
					selectedDate,
					logCode,
					intlDateLineRecord,
					vesselId,
				)
			);
		},
		getIndexOfTasks(vesselId: string) {
			return dispatch(inspectorActions.commands.getIndexOfTasks(vesselId));
		},
		setIndexOfTasks(indexOfTasks: any) {
			return dispatch(inspectorActions.document.setIndexOfTasks(indexOfTasks));
		},
		setSearchBy(searchBy: string) {
			return dispatch(inspectorActions.document.setSearchBy(searchBy));
		},
		setBooksUsingSearchBy(searchBy: string) {
			return dispatch(
				inspectorActions.document.setBooksUsingSearchBy(searchBy)
			);
		},
		setFilteredBy(filteredBy: EBookType | null) {
			return dispatch(
				inspectorActions.document.setFilteredBy(filteredBy)
			);
		},
		setShowCoverPages(show: boolean) {
			return dispatch(inspectorActions.document.setShowCoverPages(show));
		},
		loadChecklistUniqueList(vesselId: string) {
			return dispatch(checklistActions.loadChecklistUniqueList(vesselId));
		},
        loadGlobalSettings(vesselId: string) {
			return dispatch(vesselActions.globalSettingsLoad(vesselId));
		},
		loadLogbookPersonnels(vesselId: string) {
			return dispatch(vesselActions.logbookPersonnelsLoad(vesselId));
		},
		getBallastTanks(vesselId: string) {
            return dispatch(ballastActions.commands.ballastTanks(vesselId, 'BALLAST'));
        },
        setBallastTankCode(tankCode: string) {
            return dispatch(
                ballastActions.document.tankSpecificOperationBallastTankCodeSet(
                    tankCode
                )
            );
        },
	};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Inspector);
